export const RoutePaths = {
  generic: '*',
  home: '/',
  login: '/login',
  logout: '/logout',
  forgotPassword: '/forgot-password',
  preferences: '/preferences',
  success: '/success',
  badRequest: '/400'
}
